const patterns: Array<[RegExp, string]> = [
  [/matcha|green tea/i, "/menu/matcha.svg"],
  [/croissant|pastry|bakery/i, "/menu/croissant.svg"],
  [/mie|noodle|bakmi|kwetiau/i, "/menu/noodles.svg"],
  [/nasi|rice|padang|lengko/i, "/menu/rice.svg"],
  [/latte/i, "/menu/latte.svg"],
  [/chocolate|coklat|mocha/i, "/menu/chocolate.svg"],
  [/americano|espresso|cappuccino|coffee|kopi/i, "/menu/coffee.svg"],
];

const fallback = "/menu/default.svg";

/**
 * Gambar menu memakai URL dari owner bila ada; kalau kosong, pakai ilustrasi
 * lokal berdasarkan nama menu supaya tidak ada kartu menu tanpa gambar.
 */
export function menuImageFor(
  name: string,
  imageUrl?: string | null,
): string {
  const custom = imageUrl?.trim();
  if (custom) return custom;
  for (const [pattern, path] of patterns) {
    if (pattern.test(name)) return path;
  }
  return fallback;
}
